export default __webpack_public_path__ + "static/media/dish.70ee4bfc.png";